import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'
import titleImg from '../../assets/images/title.png'

import styles from './TopSection.module.scss'

interface IProps {
  title: string
  description: string
  nextStep?: () => void
  hideMobile?: boolean
  buttonText?: string
}

export const TopSection =  ({ nextStep, title, description, hideMobile, buttonText }: IProps) => {
    return(
      <div className={`${styles.Wrapper} ${hideMobile && styles.HideMobile}`}>
        <div className={styles.Container}>
          <div className={styles.Text}>
            <h1 className={styles.Title}><FormattedMessage id={title}/></h1>
            <p className={styles.Description}><FormattedMessage id={description}/></p>
            {nextStep && buttonText &&
              <div>
                <button className={styles.Btn} onClick={nextStep}><FormattedMessage id={buttonText}/></button>
              </div>
            }
          </div>
          <div className={styles.Image}>
            <img src={titleImg} alt="title section"/>
          </div>
        </div>
      </div>
    )
}


